// Kleine DOM-Helfer für die HTML-Overlays.
export function html(strings, ...values) {
  return strings.reduce((out, string, i) => out + string + (i < values.length ? values[i] ?? "" : ""), "")
}

export function escape(text) {
  return String(text ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c])
}

export function fragment(markup) {
  const template = document.createElement("template")
  template.innerHTML = markup.trim()
  return template.content.firstElementChild
}

export function animateIn(element, { from = "translate-y-4", delay = 0 } = {}) {
  element.classList.add("transition", "duration-500", "opacity-0", ...from.split(" "))
  setTimeout(() => element.classList.remove("opacity-0", ...from.split(" ")), 20 + delay)
  return element
}

export function countUp(element, from, to, { duration = 1200, format = (v) => Math.round(v) } = {}) {
  const start = performance.now()
  return new Promise((resolve) => {
    function step(now) {
      const t = Math.min(1, (now - start) / duration)
      const eased = 1 - Math.pow(1 - t, 3)
      element.textContent = format(from + (to - from) * eased)
      if (t < 1) requestAnimationFrame(step)
      else resolve()
    }
    requestAnimationFrame(step)
  })
}
